<template>
	<div class="goods">
		<v-head  :title="title"></v-head>
		<div class="content">
			<ul class="meeting_box">
				<li v-for="(item,index) in list.content" :key="index">
					<span  class="imgBox"><img :src="item.photoId" alt class></span>
					<div class="fonts">
						<h4 >{{item.meeting.name}}</h4>
						<p>举办时间： {{item.meeting.startDate | limitDate}}至{{item.meeting.endDate | limitDate}}</p>
						<p>报名时间： {{item.meeting.registerStartDate | limitDate}}至{{item.meeting.registerEndDate | limitDate}}</p>
						<p>举办地点： {{item.meeting.provinceName}}<template
								v-if="item.meeting.provinceName !== item.meeting.cityName "
						>{{item.meeting.cityName}}</template>
							{{item.meeting.address}}</p>
					</div>
					<div class="btns">
					<template v-if="!item.meetingHotel || (item.meetingHotel&&!item.meetingHotel.id)" v-show="new Date()>new Date(item.meeting.hotelStartDate)">
						<van-button round type="danger" @click="goDetail(item.meeting.id)">酒店预订</van-button>
					</template>
					<template v-else>
						<van-button round type="text" @click="cancelHotel(item.meeting,item.meetingRegister)"  v-show="new Date()<new Date(item.meeting.hotelEndDate)">宾馆取消</van-button>
					</template>
					<template v-if="item.orderInfo.orderStatus != 2">
						<van-button round type="danger">{{item.orderInfo&&item.orderInfo.orderStatus | orderStatus}}</van-button>
					</template>
					<template>
						<van-button round v-if="!item.orderInfo" round type="danger" @click="createOrder(item)">创建订单</van-button>
						<van-button round v-if="item.orderInfo && item.orderInfo.orderStatus == 2" round type="danger" @click="goPay(item.meeting)">去缴费</van-button>
					</template>
					</div>
					
				</li>
		  	</ul>
		</div>
	</div>
</template>
<script>
import vHead from "../../components/Subhead.vue";
import { Uploader,Toast,Button,ImagePreview, Dialog} from "vant";
import {registeredMeeting,createMeetingOrder, hotelCancel} from "@/api/dictionary";

export default {
  data() {
    return {
    	list:[],
		page:0,
		title: "已报名会议",
    };
  },
  components: {
    vHead,
    [Uploader.name]: Uploader,
    [Toast.name]: Toast,
    [Button.name]: Button,
    [ImagePreview.name]: ImagePreview,
	[Dialog.name]: Dialog,
  },
  filters: {
    orderStatus(val) {
      let msg = "";

      switch (val) {
        case 1:
          msg = "已删除";
          break;
        case 2:
          msg = "待支付";
          break;
        case 3:
          msg = "已取消";
          break;
        case 4:
          msg = "订单已支付";
          break;
        case 5:
          msg = "订单已完成";
          break;
        default:
          msg = "订单尚未创建";
      }
      return msg;
    }
  },
  methods: {
	  getData() {
		  let params = {
			  memberId: sessionStorage.getItem("memberId")
		  };

		  registeredMeeting(params, this.page).then(res => {
			  if (res.success) {
				  this.list = res.result;
			  }
		  });
	  },
	  go(pathName) {
	      this.$router.push({ name: pathName });
	  },
	 goDetail(meetingId) {
	      this.$router.push({
	        name: "hotelList",
	        query:{meetingId:meetingId}
	      });
	    },
	  changePage(val) {
		  this.page = val;
		  this.getData();
	  },
	createOrder(item) {
      let params = {
        meetingId: item.meeting.id,
        memberId: item.meetingRegister.memberId
      };

      createMeetingOrder(params).then(res => {
        if (res.success) {
          this.getData();
        } else {
          Toast.fail("创建订单失败");
        }
      });
    },
	goPay(meetingId){		
		this.$router.push({
			name: "payMeeting",
			query:{meetingId:meetingId}
		});
	},
	cancelHotel(meeting, meetingRegister) {
      let params = {
        meetingId: meeting.id,
        memberId: meetingRegister.memberId
      };
	  Dialog.confirm({
		title: '宾馆取消',
		message: '确认取消宾馆预订吗？',
		})
		.then(() => {
		  hotelCancel(params).then(res => {
			if (res.success) {
				this.getData();
				Toast.success("取消成功");
			} else {
				Toast.fail("取消失败");
			}
			});
		})
		.catch(() => {
			// on cancel
	  });
    },
  },
	mounted() {
  		this.getData();
  		//this.title = "aa"
  		// this.$route.meta.title = title?title +"会员列表" : "分会会员列表";
	}
};
</script>

<style  lang="less" scoped>
.means{
 padding:20px 13px 15px 13px; background:url(../../assets/images/hy_bg.jpg); background-size: 100%; overflow:hidden;
.van-button{ float: right; background: #fff; color: #378be1; border:none; line-height: 26px; height: 35px;  margin-top: 8px;}
}
.portrait{ width:15%; float:left;}
.means_name{float:left; font-size:14px; color:#fff; margin-top:5px;line-height:24px; margin-left:10px;}
.more{ float:right; margin-top:25px; color:#fff;}
.means_top{ overflow: hidden; }
.mean_bottom{ font-size: 14px; color: #fff;  margin-top: 15px;
   .left_c{ float: left; line-height: 26px;}
}

.menu { padding:15px 0; border-bottom: #f2f2f2 8px solid;
.van-col{ text-align: center; 
           img{ display: block; width: 45%; margin:0 auto; }
           span{ font-size: 13px;  margin-top:10px; display:block;}
	    }
 }
.meeting_box{ 
	padding:15px; 
	img{ width: 100%; max-height: 5.2rem}
	li{border-bottom:#dfdfdf solid 1px; padding-bottom: 15px; position: relative; margin-bottom: 15px;}
	
		.btns{
			display: flex;
			padding:14px 0 14px 0;
			.van-button{background: #378be1; color: #fff; border:none; line-height: 26px; height: 30px; margin-right: 4px;
		}
		}
    
}
.fonts{ font-size: 13px; line-height: 24px; margin-top: 10px; width: 70%;}
.meeting_box li .imgBox{ height: 5.98rem; background: url(../../assets/images/mor.jpg); background-size:100%;
display: block; }
/deep/.van-ellipsis{ display: inline-block; line-height: 50px;color: #dfdfdf;}
/deep/.van-nav-bar__text{color: #dfdfdf;}
</style>